'use client';

import { useQuery } from '@tanstack/react-query';
import { useAuth } from 'react-oidc-context';

import { getMultipleReviewInfos } from '../apis/feedbacks';
import type { FeedbackTopicType, ReviewInfoResponseType } from '../types/feedbacks';

type Args = {
  topicIds: string[];
  topicType: FeedbackTopicType;
  enabled?: boolean;
  onSuccess?: (d: ReviewInfoResponseType[]) => void;
};

export const useMultipleReviewInfo = (args: Args) => {
  const { topicIds, topicType, onSuccess, enabled } = args;
  const { user } = useAuth();
  return useQuery(
    ['review-info-multi', topicIds.toString(), topicType],
    async () => {
      const res = await getMultipleReviewInfos(topicType, topicIds, user?.access_token as string);
      return res.data;
    },
    {
      enabled,
      onSuccess(data) {
        onSuccess && onSuccess(data);
      },
    },
  );
};
